import React from 'react';
import { EventNameNav, EventNameNavProps } from '../components/EventNameNav';
import type { WebsiteHeaderLayout_Center } from '@shared/types/WebsiteHeaderSettings.types';
import { HeaderPhoto } from '../components/HeaderPhoto/HeaderPhoto';
import { CenterPhoto } from '../components/CenterPhoto/CenterPhoto';

interface CenterLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_Center;
  showPlaceholder?: boolean;
}

export const CenterLayout = (props: CenterLayoutProps) => {
  const { websiteHeader, showPlaceholder = false, ...restProps } = props;

  const photo = websiteHeader.headerPhoto.photos?.[0];

  return (
    <EventNameNav
      eventDisplayName={websiteHeader.eventDisplayName}
      {...restProps}
    >
      <HeaderPhoto
        websiteHeader={websiteHeader}
        pageSlug={restProps.pageSlug}
        pageType={restProps.page}
        showPlaceholder={showPlaceholder}
      >
        <CenterPhoto
          photo={photo}
          showPlaceholder={showPlaceholder}
        />
      </HeaderPhoto>
    </EventNameNav>
  );
};
